import currencyFormatter from 'currency-formatter';

export function hasLearners(elbSubscription) {
  return elbSubscription.plan &&  (elbSubscription.plan.hasLearners /* || elbSubscription.plan.nickname.includes('platinum')*/);
}

export function removePlanByNamePartial(availablePlans, name) {
  const index = availablePlans.findIndex((v) => v.productName.includes(name));
  if (index !== -1) {
    availablePlans.splice(index, 1);
  }
}

export function removePlanByMetadata(availablePlans) {
  availablePlans = availablePlans
    .filter((plan) => plan.price.metadata && (plan.price.metadata.dependsOn || plan.price.metadata.learner))
    .forEach((x) => availablePlans.splice(availablePlans.indexOf(x), 1));
}

export function removePlanIfHasDependsOn(availablePlans) {
  availablePlans = availablePlans
    .filter((plan) => plan.price.metadata && plan.price.metadata.dependsOn)
    .forEach((x) => availablePlans.splice(availablePlans.indexOf(x), 1));
}

export function removePlanLearnerType(availablePlans) {
  const plans = [];

    for (const index in availablePlans) {
      const plan = availablePlans[index];
      if (plan.price.metadata.related) {
        const related = JSON.parse(plan.price.metadata.related);
        if (related && related.type && related.type !== 'learner_inc_author') {
          plans.push(plan);
        }
      }
    }
    return plans;
}

export function removeExistingPlans(subscriptionItems, availablePlans) {
  for (let i = 0; i < subscriptionItems.length; i++) {
    removePlanByNamePartial(availablePlans, subscriptionItems[i].productName);
  }
}

export function removeExistingSubscription(subscriptions, availablePlans) {
  if (!subscriptions) {
    return;
  }
  for (let i = 0; i < subscriptions.length; i++) {
    removePlanByNamePartial(availablePlans, subscriptions[i].plan.name);
  }
}

export function showQtyInSelect(plan) {
  return plan.productName.includes('viewers') || plan.price.id.includes('learner');
}

export function hasLearner(name) {
  return name.includes('learner');
}

export function getAddonItem(addons, item, availablePlans) {
  for (const index in addons) {
    const addon = addons[index];

    if (addon) {
      const priceId = item.interval === 'month' ? addon.monthlyStripeId : addon.yearlyStripeId;
      const addonItem = availablePlans.find((val) => val.priceId === priceId);

      if (addonItem) {
        return {
          productName: addonItem.productName,
          quantity: addon.maxValue,
          priceId: addonItem.priceId,
          interval: addonItem.interval,
          unitPrice: addonItem.unitPrice,
          deleted: false,
          added: true,
          billing: addonItem.billing,
        };
      }
    }
  }
  return null;
}

export function getUnitPriceForTierCamel(tiers, quantity: number) {
  for (let i = 0; i < tiers.length; i++) {
    const tier = tiers[i];

    if (tier.upTo == null) {
      return tier.unitAmountDecimal;
    }

    if (tier.upTo >= quantity) {
      return tier.unitAmountDecimal;
    }
  }
}

export function getIvoiceSubscriptionItems(subscriptionItems, allPlans) {
  const invoiceItems = [];
  const itemsToSkip = getItemsToSkip(subscriptionItems);
  for (let i = 0; i < subscriptionItems.length; i++) {
    const subscriptionItem = subscriptionItems[i];
    if (itemsToSkip.find((s) => s.priceId === subscriptionItem.priceId)) {
      continue;
    }

    const invoiceItem = buildInvoiceItem(subscriptionItem, allPlans);
    invoiceItems.push(invoiceItem);
  }

  return invoiceItems;
}

export function getItemsToSkip(subscriptionItems) {
  const itemsToSkip = [];
  subscriptionItems.forEach((elem) => {
    if (elem.relatedAuthor) {
      itemsToSkip.push(elem.relatedAuthor);
    }

    if (elem.relatedLearner) {
      itemsToSkip.push(elem.relatedLearner);
    }
  });

  return itemsToSkip;
}

export function findByPriceName(priceName, allPlans, qty) {
  const plan = allPlans.find((p) => p.priceId === priceName);
  if (plan) {
    const related = {
      quantity: Number(qty),
      priceId: plan.priceId,
      interval: plan.interval,
      deleted: false,
      added: true,
      productName: plan.productName,
      unitPrice: plan.billing === 'per_unit' ? plan.price.unitAmount : getUnitPriceForTierCamel(plan.price.tiers, qty),
      billing: plan.billing,
    };
    return related;
  }
}

export function buildInvoiceItem(subscriptionItem, allPlans) {
  let amount = 0;
  let unitPrice = 0;
  let needsQtySelect = false;
  let authorOnly = null;
  let learnerAuthorList = null;
  let learnerList = null;
  let learner = subscriptionItem.relatedLearner ? subscriptionItem.relatedLearner : null;
  let learnerLowPrice = '$5.00';

  if (subscriptionItem.billing === 'per_unit') {
    unitPrice = subscriptionItem.unitPrice;
    amount = subscriptionItem.unitPrice * subscriptionItem.quantity;
    learnerLowPrice = currencyFormatter.format(unitPrice / 100.0, { code: 'USD' });
  } else {
    const plan = allPlans.find((p) => p.productName === subscriptionItem.productName && p.priceId === subscriptionItem.priceId);
    if (plan) {
      unitPrice = getUnitPriceForTierCamel(plan.price.tiers, subscriptionItem.quantity);
            amount = unitPrice * subscriptionItem.quantity;
      needsQtySelect = showQtyInSelect(plan);
      if (plan.price.metadata) {
        const related = plan.price.metadata.related ? JSON.parse(plan.price.metadata.related) : null;
        authorOnly = plan.price.metadata.authorOnly;
        learnerAuthorList = plan.price.metadata.learnerAuthorList ? JSON.parse(plan.price.metadata.learnerAuthorList) : null;
        learnerList = plan.price.metadata.learnerList ? JSON.parse(plan.price.metadata.learnerList) : null;
        if (!learner && related && related.learner) {
          learner = findByPriceName(related.learner, allPlans, 0);
        }

        if (related && related.learner) {

          const learnerPlan = allPlans.find((p) => p.priceId === related.learner);
          if (learnerList && learnerPlan && learnerPlan.price && learnerPlan.price.tiers) {
            const p = getUnitPriceForTierCamel(learnerPlan.price.tiers, learnerList[learnerList.length - 1]);
            learnerLowPrice = currencyFormatter.format( p / 100.0, { code: 'USD' });
            // update relatedLearner prices
            if (learner && learner.quantity) {
              const learnerUnitPrice = getUnitPriceForTierCamel(learnerPlan.price.tiers, learner.quantity);
              learner.unitAmount = currencyFormatter.format(learnerUnitPrice / 100.0, { code: 'USD' });

            }
          }
        }
      }
    }
  }

  const computedAmount = currencyFormatter.format(amount / 100.0, { code: 'USD' });
  const unitAmount = currencyFormatter.format(unitPrice / 100.0, { code: 'USD' });

  return {
    id: subscriptionItem.id,
    priceId: subscriptionItem.priceId,
    productName: subscriptionItem.productName,
    quantity: subscriptionItem.quantity,
    unitAmount,
    unitAmountPerPeriod: unitAmount + ' / ' + subscriptionItem.interval,
    computedAmount,
    computedAmountPerPeriod: computedAmount + ' / ' + subscriptionItem.interval,
    deleted: subscriptionItem.deleted,
    billing: subscriptionItem.billing,
    showQtySelect: needsQtySelect,
    relatedAuthor: subscriptionItem.relatedAuthor,
    relatedLearner: learner,
    authorOnly,
    learnerAuthorList: learnerAuthorList ? learnerAuthorList : learnerList,
    learnerLowPrice
  };
}


export function formatPrice(price) {
  return  currencyFormatter.format(price / 100.0, { code: 'USD' });
}

export function updateAdditionalAuthors(related, addAdditionalAuthors) {
  if (related) {
    related.quantity = addAdditionalAuthors;
    return related;
  }
}

export function getAdditionalAuthors(item, addAdditionalAuthors, allPlans) {
  const plan = allPlans.find((p) => p.price.metadata && p.price.metadata.dependsOn && p.price.metadata.dependsOn.includes(item.priceId));
  if (plan && addAdditionalAuthors > 0) {
    const related = {
      quantity: Number(addAdditionalAuthors),
      priceId: plan.priceId,
      interval: 'year',
      deleted: false,
      added: true,
      productName: plan.productName,
      unitPrice: plan.price.unitAmount,
      billing: 'per_unit',
    };

    return related;
  }
}

export function buildSubscriptionItem(item: any): any {
  if (!item) {
    return null;
  }

  let unitPrice = 0;
  if (item.price.unit_amount) {
    unitPrice = item.price.unit_amount;
  } else if (item.price.tiers) {
    unitPrice = getUnitPriceForTierCamel(item.price.tiers, item.quantity);
  }

  const subsItem = {
    id: item.id,
    productName: item.price.product.name,
    quantity: item.quantity,
    priceId: item.price.id,
    interval: item.price.recurring.interval,
    unitPrice,
    unitAmount: formatPrice(unitPrice),
    deleted: false,
    added: false,
    billing: item.price.billing_scheme
  };

  return subsItem;

}

export function getRelated(subscriptionItems, item) {
  const relatedObj = {};
  if (item.price.metadata && item.price.metadata.related) {
    const related = JSON.parse(item.price.metadata.related);
    const author = related.author;
    const learner = related.learner;
    subscriptionItems.forEach((elm) => {
      if (elm.price.id === author) {
        relatedObj['relatedAuthor'] = elm;
      }

      if (elm.price.id === learner) {
        relatedObj['relatedLearner'] = elm;
      }
    });
  }
  return relatedObj;
}

export function getImgForPlan(planName: string) {
  const words = planName.split(' ');
  const plan = words[0];
  switch (plan) {
    case 'Silver':
      return '../../../content/images/5f05b363c84aef948081d215_AuthoringSuiteDrumSet_Silver.png'; // silver
    case 'Gold':
      return '../../../content/images/5ed5670f7d7cfca81cf21540_AuthoringSuiteDrumSet_Gold.png'; // gold
    case 'Platinum':
      return '../../../content/images/5ed5670f7d7cfc5776f21541_AuthoringSuiteDrumSet_Platinum.png'; // Platinum
    default:
      return '../../../content/images/5f05b363c84aef948081d215_AuthoringSuiteDrumSet_Silver.png'; // silver
  }
}

export function getPlansExcluding(planName: string) {
  const words = planName.split(' ');
  const plan = words[0];
  const retVal = [];
  const platinumPlan = plans.find((o) => o.name === 'platinum');
  platinumPlan.selected = false;
  switch (plan) {
    case 'Silver': {
      retVal.push(plans.find((o) => o.name === 'gold'));
      retVal.push(platinumPlan);
      break;
    } // silver
    case 'Gold': {
      retVal.push(platinumPlan);
      break;
    } // gold
    case 'Platinum':
      break; // Platinum
    default: {
      retVal.push(plans.find((o) => o.name === 'gold'));
      retVal.push(platinumPlan);
    }
  }

  return retVal;
}

export function getPlanByName(planName) {
  const words = planName.split(' ');
  const plan = words[0];
  let retVal = {};
  const platinumPlan = plans.find((o) => o.name === 'platinum');
  platinumPlan.selected = false;
  switch (plan) {
    case 'Silver': {
      retVal = Object.assign(
        {},
        plans.find((o) => o.name === 'silver')
      );
      break;
    } // silver
    case 'Gold': {
      retVal = Object.assign(
        {},
        plans.find((o) => o.name === 'gold')
      );
      break;
    } // gold
    case 'Platinum':
      retVal = Object.assign({}, platinumPlan);
      break; // Platinum
  }

  return retVal;
}

export function getPlanByNickname(planNickname) {
  const retVal = Object.assign(
    {},
    plans.find((o) => o.buy === planNickname)
  );
  retVal.selected = false;
  return retVal;
}

export function getPlansByName(planName) {
  const words = planName.split(' ');
  const plan = words[0];
  const retVal = [];
  const platinumPlan = plans.find((o) => o.name === 'platinum');
  platinumPlan.selected = false;
  switch (plan) {
    case 'Silver': {
      retVal.push(plans.find((o) => o.name === 'silver'));
      break;
    } // silver
    case 'Gold': {
      retVal.push(plans.find((o) => o.name === 'gold'));
      break;
    } // gold
    case 'Platinum':
      retVal.push(platinumPlan);
      break; // Platinum
  }

  return retVal;
}

export const plans = [
  {
    name: 'silver',
    title: 'Silver Suite',
    img: '../../../content/images/5f05b363c84aef948081d215_AuthoringSuiteDrumSet_Silver.png',
    price: '$999',
    priceInterval: 'yr',
    priceSavings: 'A $4,000 value!',
    selected: false,
    cardColor: 'card-white ',
    buy: 'elb_silver_suite',
    trial: 'elb_silver_suite_trial',
    products: [
      {
        id: 1,
        name: 'Lectora® Online',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 2,
        name: 'Lectora® Desktop',
        color: '#D5D5D9',
        icon: '',
      },
      {
        id: 3,
        name: 'ReviewLink™',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 4,
        name: 'AssetLibrary (In-App)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 5,
        name: 'AssetLibrary (Full Access)',
        color: '#D5D5D9',
        icon: '',
      },
      {
        id: 6,
        name: 'Cenario VR',
        color: '#D5D5D9',
        icon: '',
      },
    ],
  },
  {
    name: 'gold',
    title: 'Gold Suite',
    img: '../../../content/images/5ed5670f7d7cfca81cf21540_AuthoringSuiteDrumSet_Gold.png',
    price: '$1,399',
    priceInterval: 'yr',
    priceSavings: 'A $7,000 value!',
    selected: false,
    buy: 'elb_gold_suite',
    trial: 'elb_gold_suite_trial',
    products: [
      {
        id: 1,
        name: 'Lectora® Online',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 2,
        name: 'Lectora® Desktop',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 3,
        name: 'ReviewLink™',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 4,
        name: 'AssetLibrary (In-App)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 5,
        name: 'AssetLibrary (Full Access)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 6,
        name: 'Cenario VR',
        color: '#D5D5D9',
        icon: '',
      },
    ],
  },
  {
    name: 'platinum',
    title: 'Platinum Suite',
    img: '../../../content/images/5ed5670f7d7cfc5776f21541_AuthoringSuiteDrumSet_Platinum.png',
    price: '$1,999',
    priceInterval: 'yr',
    priceSavings: 'A $9,000 value!',
    selected: true,
    buy: 'elb_platinum_suite',
    trial: 'elb_platinum_suite_trial',
    products: [
      {
        id: 1,
        name: 'Lectora® Online',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 2,
        name: 'Lectora® Desktop',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 3,
        name: 'ReviewLink™',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 4,
        name: 'AssetLibrary (In-App)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 5,
        name: 'AssetLibrary (Full Access)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 6,
        name: 'Cenario VR',
        color: 'green',
        icon: 'mdi-check',
      },
    ],
  },
  {
    name: 'silver_monthly',
    title: 'Silver Suite',
    img: '../../../content/images/5f05b363c84aef948081d215_AuthoringSuiteDrumSet_Silver.png',
    price: '$110',
    priceInterval: 'month',
    priceSavings: 'A $4,000 value!',
    selected: false,
    cardColor: 'card-white ',
    buy: 'elb_silver_suite_monthly',
    trial: 'elb_silver_suite_trial',
    products: [
      {
        id: 1,
        name: 'Lectora® Online',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 2,
        name: 'Lectora® Desktop',
        color: '#D5D5D9',
        icon: '',
      },
      {
        id: 3,
        name: 'ReviewLink™',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 4,
        name: 'AssetLibrary (In-App)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 5,
        name: 'AssetLibrary (Full Access)',
        color: '#D5D5D9',
        icon: '',
      },
      {
        id: 6,
        name: 'Cenario VR',
        color: '#D5D5D9',
        icon: '',
      },
    ],
  },
  {
    name: 'gold_monthly',
    title: 'Gold Suite',
    img: '../../../content/images/5ed5670f7d7cfca81cf21540_AuthoringSuiteDrumSet_Gold.png',
    price: '$149',
    priceInterval: 'month',
    priceSavings: 'A $7,000 value!',
    selected: false,
    buy: 'elb_gold_suite_monthly',
    trial: 'elb_gold_suite_trial',
    products: [
      {
        id: 1,
        name: 'Lectora® Online',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 2,
        name: 'Lectora® Desktop',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 3,
        name: 'ReviewLink™',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 4,
        name: 'AssetLibrary (In-App)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 5,
        name: 'AssetLibrary (Full Access)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 6,
        name: 'Cenario VR',
        color: '#D5D5D9',
        icon: '',
      },
    ],
  },
  {
    name: 'platinum_monthly',
    title: 'Platinum Suite',
    img: '../../../content/images/5ed5670f7d7cfc5776f21541_AuthoringSuiteDrumSet_Platinum.png',
    price: '$211',
    priceInterval: 'month',
    priceSavings: 'A $9,000 value!',
    selected: true,
    buy: 'elb_platinum_suite_monthly',
    trial: 'elb_platinum_suite_trial',
    products: [
      {
        id: 1,
        name: 'Lectora® Online',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 2,
        name: 'Lectora® Desktop',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 3,
        name: 'ReviewLink™',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 4,
        name: 'AssetLibrary (In-App)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 5,
        name: 'AssetLibrary (Full Access)',
        color: 'green',
        icon: 'mdi-check',
      },
      {
        id: 6,
        name: 'Cenario VR',
        color: 'green',
        icon: 'mdi-check',
      },
    ],
  },
];
